import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const esPublicSiteOverride = {
  content: {
    brand: {
      tagline: 'Planes con vida, no atascados',
    },
    routes: [
      { label: 'Resumen', title: 'The Timelining App', description: 'Un espacio visual de planificación con economía de créditos, revisión de IA y un ciclo RPG que mantiene vivos los planes.' },
      { label: 'Soluciones', title: 'Soluciones', description: 'Flujos reales: lanzamientos, agencias, creadores, estudiantes, operaciones de campo y cohortes.' },
      { label: 'Guía', title: 'Guía', description: 'La guía completa: de un espacio vacío a un plan enviado, con cada superficie, rol y ceremonia documentados.' },
      { label: 'Recursos', title: 'Recursos', description: 'Patrones listos para copiar, biblioteca de prompts de IA, plantillas de checklist y ritmos de trabajo.' },
      { label: 'Precios', title: 'Precios', description: 'Precios por economía de créditos. Paga por lo que consumes, no por asientos.' },
      { label: 'Descargar', title: 'Descargar', description: 'Instala las apps Android Member y Helper desde la página pública de descarga.' },
      { label: 'Acerca de', title: 'Acerca de', description: 'Por qué existe esta app, qué defiende, qué ya se lanzó y qué viene después.' },
      { label: 'FAQ', title: 'FAQ', description: '25 preguntas sobre configuración, IA, gamificación, equipos y datos.' },
      { label: 'Contacto', title: 'Contacto', description: 'Escríbenos para pilotos, soporte, feedback, demos y prensa.' },
    ],
    hero: {
      eyebrow: 'Planificación visual · créditos · revisión de IA',
      headline: 'Planes con vida, no atascados',
      accent: 'con vida',
      primaryCtaSignedOut: 'Abrir la app',
      primaryCtaSignedIn: 'Abrir mi espacio',
      secondaryCta: 'Leer la guía',
      consoleNoteSignedOut: 'El inicio de sesión se abre dentro de la app privada.',
      consoleNoteSignedIn: 'Ya iniciaste sesión. Continúa desde tu espacio actual.',
    },
    ctaBand: {
      eyebrow: '¿Listo?',
      title: 'Abre la Console. O descarga la app.',
      primary: 'Abrir Console',
      secondary: 'Obtener APK',
    },
  },
  chrome: {
    nav: {
      ariaLabel: 'Navegación pública',
      brandHomeSuffix: 'inicio',
      contact: 'Contacto',
      getStarted: 'Empezar',
      languageLabel: 'Idioma',
      languageAriaLabel: 'Idioma del sitio',
    },
    common: {
      openWorkspace: 'Abrir mi espacio',
      openConsole: 'Abrir Console',
      featureColumnHeader: 'Función',
      capabilityColumnHeader: 'Capacidad',
    },
    download: {
      eyebrow: 'Obtener Timelining',
      title: 'Instala las apps Android.',
      downloadApk: 'Descargar APK',
      copyLink: 'Copiar enlace',
      share: 'Compartir',
    },
  },
} satisfies PublicSiteLocaleOverride
